var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bullets-wrap"},_vm._l((_vm.slidesAmount),function(i){return _c('div',{staticClass:"bullet",class:{
            'palette-background-trigger palette-border-trigger': i - 1 === _vm.current
        }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }